import { render, staticRenderFns } from "./EditAnswerComment.vue?vue&type=template&id=55d82508&"
import script from "./EditAnswerComment.vue?vue&type=script&lang=js&"
export * from "./EditAnswerComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports